import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import UserApi from "../../services/users";
import DashboardHeader from '../../components/DashboardHeader';

function CreateUserPage(props) {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        password: '',
        profile_image: '',
        is_verified: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');


    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const userApi = new UserApi(props.token);
            
            // Prepare user data - include all fields that have values
            let userData = {
                email: formData.email,
                first_name: formData.first_name,
                last_name: formData.last_name
            };

            // Add optional fields if they have values
            if (formData.password) {
                userData.password = formData.password;
            }
            
            if (formData.phone) {
                userData.phone = formData.phone;
            }
            
            if (formData.profile_image) {
                userData.profile_image = formData.profile_image;
            }
            
            if (formData.is_verified) {
                userData.is_verified = formData.is_verified;
            }

            const result = await userApi.createUser(userData);
            console.log('User created successfully:', result);
            
            // Navigate back to users list
            navigate('/users');
        } catch (error) {
            console.error('Error creating user:', error);
            setError(error.message || 'Failed to create user. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="Back to Users" link='/users' />
            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Add New User</h2>
                </div>
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            {error && (
                                <div className="alert alert-danger mb-3">
                                    {error}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="first_name" className="form-label">First Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="first_name"
                                            name="first_name"
                                            value={formData.first_name}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="last_name" className="form-label">Last Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="last_name"
                                            name="last_name"
                                            value={formData.last_name}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            autoComplete="new-password"
                                            placeholder="Enter a secure password (optional)"
                                        />
                                        <div className="form-text">Leave blank for OAuth users</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="profile_image" className="form-label">Profile Image URL</label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            id="profile_image"
                                            name="profile_image"
                                            value={formData.profile_image}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            placeholder="https://example.com/avatar.jpg"
                                        />
                                        <div className="form-text">Optional profile image URL</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="is_verified" className="form-label">Verified</label>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="is_verified"
                                                name="is_verified"
                                                checked={formData.is_verified}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label" htmlFor="is_verified">
                                                User is verified
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Creating...' : 'Create User'}
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-secondary ms-2"
                                        onClick={() => navigate('/users')}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateUserPage
